import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Headings } from '../../components';
import { data } from '../../constants';

import CoursePlan1 from '../../components/CoursePlans/CoursePlan1';
import CoursePlan2 from '../../components/CoursePlans/CoursePlan2';
import CoursePlan3 from '../../components/CoursePlans/CoursePlan3';
import CoursePlan4 from '../../components/CoursePlans/CoursePlan4';

import Registration1 from '../../components/Registrations/Registration1';
import Registration2 from '../../components/Registrations/Registration2';
import Registration3 from '../../components/Registrations/Registration3';
import Registration4 from '../../components/Registrations/Registration4';

import './Courses.css';

const Courses = () => {
  return (
    <>
      <div id="courses" className="d-block pt-md-4">
        <div style={{ color: 'black', fontWeight: 'bold' }}>
          <Headings title="Courses" text="We designed our courses specially for Bangladeshi Gen Z to lead the future world..." />
        </div>

        <div className="row">
          {data.ServicesData.map(({ titleone, titletwo, link, itemclass, imgURL }, index) => (
            <div className="col-lg-6 col-12" key={index}>
              <div className={`row ${itemclass}`}>
                <div>
                  <div>
                    <span>{titleone} </span>
                    <span style={{color:'green'}}>{titletwo}</span>
                  </div>
                  <div className="d-flex gap-2 mt-2">
                    <a href={`/course-plan-${index + 1}`} className="btn btn-primary custom-btn">
                      Course Plan
                    </a>
                    <a href={`/registration-${index + 1}`} className="btn btn-success custom-btn">
                      Registration
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
{/* 
        <Routes>
          <Route path="/course-plan-1" element={<CoursePlan1 />} />
          <Route path="/course-plan-2" element={<CoursePlan2 />} />
          <Route path="/course-plan-3" element={<CoursePlan3 />} />
          <Route path="/course-plan-4" element={<CoursePlan4 />} />
          <Route path="/registration-1" element={<Registration1 />} />
          <Route path="/registration-2" element={<Registration2 />} />
          <Route path="/registration-3" element={<Registration3 />} />
          <Route path="/registration-4" element={<Registration4 />} />
        </Routes> */}
      </div>
    </>
  );
};

export default Courses;

